import { render, staticRenderFns } from "./IngresoPetroleo.vue?vue&type=template&id=936a216e&"
import script from "./IngresoPetroleo.vue?vue&type=script&lang=js&"
export * from "./IngresoPetroleo.vue?vue&type=script&lang=js&"
import style0 from "./IngresoPetroleo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports